<template>

    <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">

        <!--DELETE - Dialog-->
        <v-dialog
                persistent
                v-model="deleteDialog" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="headline">Delete Supplier Order Proforma</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form" v-model="deleteFormValidation" lazy-validation>
                        <v-checkbox
                                :rules="[v => !!v || 'You have to check this to continue!']"
                                required
                                v-model="deleteChecked" color="primary"
                                label="Do you really want to delete this proforma?"></v-checkbox>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="cancelDeleteDialog(() => {
                            cancelDeleteDialogCallback()
                    })">CANCEL
                    </v-btn>
                    <v-btn color="primary darken-1" flat @click.native="executeDelete(() => {
                            executeDeleteDialogCallback()
                    })">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Add Edit - SupplierOrder -->

        <v-toolbar tabs fixed light color="white">
            <v-btn icon @click.native="closeDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedItem.id === 0">Add Supplier Order</v-toolbar-title>
            <v-toolbar-title v-else>Edit Supplier Order - {{selectedItem.purchase_orders_number}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tabs slot="extension"
                    v-model="activeTabIndex"
                    color="secondary"
                    dark
                    slider-color="primary"
                    class="fixSides"
                    show-arrows

            >
                <v-tab >SUPPLIER ORDER</v-tab>
                <v-tab :disabled="tabsDisabled">SUPPLIER ORDER POSITIONS</v-tab>
                <v-tab :disabled="sendSupplierOrderDisabled">SEND SUPPLIER ORDER</v-tab>
            </v-tabs>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>
                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="deleteAll()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-tabs-items class="fromTop" v-model="activeTabIndex"
                      :touchless="touchless"
        >
            <v-tab-item>

                <v-layout wrap>
                    <v-container grid-list-md>
                        <v-flex xs12 md10 offset-md1 xl6 offset-xl3>
                            <v-hover>
                                <v-card slot-scope="{ hover }"
                                        :class="`elevation-${hover ? 4 : 1}`">
                                    <v-card-title class="headline">{{cardTitle}} Supplier Order
                                        <v-spacer></v-spacer>
                                        <!--                                        <v-autocomplete v-show="!getInitialLoading"
                                                                                                v-if="selectedItem.id > 0"
                                                                                                class="statusSelecter"
                                                                                                :items="statuses"
                                                                                                item-text="name"
                                                                                                item-value="id"
                                                                                                label="Supplier Order Status"
                                                                                                v-model="selectedItem.purchase_orders_status_id"
                                                                                                required
                                                                                ></v-autocomplete>-->
                                    </v-card-title>

                                    <v-card-title>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Supplier</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>


                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete v-show="!getInitialLoading"
                                                            clearable
                                                            :items="getAllSuppliers"
                                                            label="Supplier"
                                                            v-model="selectedItem.suppliers_id"
                                                            item-value="id"
                                                            item-text="name"
                                                            :loading="loading"
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete v-show="!getInitialLoading"
                                                            class="contactPerson"
                                                            label="Contact Person"
                                                            v-model="selectedItem.suppliers_contacts_id"
                                                            persistent-hint
                                                            :items="getSupplierContacts"
                                                            :filter="customContactFilter"
                                                            item-value="id"
                                                            item-text="name"
                                                            clearable
                                                            :loading="loading"

                                            >
                                                <template slot="selection" slot-scope="data">
                                                    {{ data.item.title ? data.item.title : '' }} {{
                                                    data.item.firstname
                                                    }} {{
                                                    data.item.lastname }}
                                                </template>

                                                <template slot="item" slot-scope="data">
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>
                                                            {{ data.item.title ? data.item.title : '' }} {{
                                                            data.item.firstname }} {{
                                                            data.item.lastname }}
                                                        </v-list-tile-title>

                                                        <v-list-tile-sub-title v-if="data.item.main_contact"
                                                        >Main Contact
                                                        </v-list-tile-sub-title>

                                                    </v-list-tile-content>
                                                </template>

                                                <template slot="no-data">
                                                    <v-layout wrap>
                                                        <v-flex xs12 pl-4 pr-4>
                                                            <v-btn @click.native="openNewSupplierContactDialog()" block
                                                                   small flat color="secondary">Create New contact
                                                                <v-icon>add</v-icon>
                                                            </v-btn>
                                                        </v-flex>

                                                    </v-layout>
                                                </template>

                                            </v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Supplier Purchase Order Confirmation</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>


                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field v-show="!getInitialLoading"
                                                          label="Supplier Order Confirmation Number"
                                                          v-model="selectedItem.suppliers_orders_confirmation_number"
                                                          required
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <UploadDocumentPicker v-show="!getInitialLoading"
                                                                  v-model="uploadedDocument"
                                                                  label="Select PDF"
                                            >
                                            </UploadDocumentPicker>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <v-layout>
                                                <v-spacer></v-spacer>
                                                <DocumentTokenChip
                                                        v-show="selectedItem.documents_id !== 0 && selectedItem.documents_id !== null && !getInitialLoading"
                                                        :documentsId="selectedItem.documents_id"
                                                        :documentFilename="selectedItem.suppliers_orders_confirmation_number + '.pdf'"
                                                >
                                                </DocumentTokenChip>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <DatetimePicker v-show="!getInitialLoading"
                                                            locale="de-DE"
                                                            landscape
                                                            mysql
                                                            :width="width = 500"
                                                            label="Confirmation Received at"
                                                            v-model="selectedItem.confirmation_received"
                                                            format="DD.MM.YYYY HH:mm"
                                            >
                                            </DatetimePicker>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <DatetimePicker v-show="!getInitialLoading"
                                                            locale="de-DE"
                                                            landscape
                                                            mysql
                                                            :width="width = 500"
                                                            label="Paid at"
                                                            v-model="selectedItem.paid_at"
                                                            format="DD.MM.YYYY"
                                                            dateOnly
                                            >
                                            </DatetimePicker>
                                        </v-flex>


                                        <v-flex xs12 pr-3 pl-3>
                                            <v-layout row wrap pb-2>
                                                <v-subheader>Proforma</v-subheader>
                                                <v-spacer></v-spacer>
                                                <v-switch color="secondary" class="header-switch" v-model="proforma" label=""></v-switch>
                                            </v-layout>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-layout row wrap v-show="proforma">

                                            <v-flex xs12 md6 pl-4 pa-2>
                                                <FakeItem v-show="getInitialLoading">
                                                </FakeItem>

                                                <v-text-field v-show="!getInitialLoading"
                                                              label="Supplier Order Proforma created"
                                                              :value="selectedSupplierOrderProforma.created_at | toDateTimeLocalTime"
                                                              readonly
                                                              prepend-icon='fas fa-calendar'
                                                              :disabled="selectedSupplierOrderProforma.created_at === null"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 md6 pl-4 pa-2>
                                                <FakeItem v-show="getInitialLoading">
                                                </FakeItem>
                                                <v-autocomplete
                                                        v-show="!getInitialLoading"
                                                        :items="proformaStatuses"
                                                        item-text="name"
                                                        item-value="id"
                                                        label="Supplier Order Proforma Status"
                                                        v-model="selectedSupplierOrderProforma.suppliers_orders_proforma_status_id"
                                                        required
                                                ></v-autocomplete>
                                            </v-flex>

                                            <v-flex xs12 md6 pl-4 pa-2>
                                                <FakeItem v-show="getInitialLoading">
                                                </FakeItem>
                                                <v-text-field v-show="!getInitialLoading"
                                                              label="Supplier Order Proforma Number"
                                                              v-model="selectedSupplierOrderProforma.proforma_number"
                                                              required
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 md6 pl-4 pa-2>
                                                <FakeItem v-show="getInitialLoading">
                                                </FakeItem>
                                                <UploadDocumentPicker v-show="!getInitialLoading"
                                                                      v-model="uploadedProformaDocument"
                                                                      label="Select Supplier Order Proforma PDF"
                                                >
                                                </UploadDocumentPicker>
                                            </v-flex>

                                            <v-flex xs12 md6 pl-4 pa-2>
                                                <FakeItem v-show="getInitialLoading">
                                                </FakeItem>
                                                <v-autocomplete v-show="!getInitialLoading"
                                                                clearable
                                                                :items="['100', '50']"
                                                                label="Payment Term"
                                                                v-model="selectedSupplierOrderProforma.payment_term_percent"
                                                                prepend-icon='fas fa-percent'
                                                ></v-autocomplete>
                                            </v-flex>

                                            <v-flex xs12 md6 pl-4 pa-2>
                                                <v-layout>
                                                    <v-spacer></v-spacer>

                                                    <FakeItem v-show="getInitialLoading">
                                                    </FakeItem>
                                                    <DocumentTokenChip
                                                            v-show="selectedSupplierOrderProforma.documents_id !== 0 && selectedSupplierOrderProforma.documents_id !== null && !getInitialLoading"
                                                            :documentsId="selectedSupplierOrderProforma.documents_id"
                                                            :documentFilename="selectedSupplierOrderProforma.proforma_number + '.pdf'"
                                                    >
                                                    </DocumentTokenChip>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 md6 pl-4 pa-2>
                                                <FakeItem v-show="getInitialLoading">
                                                </FakeItem>
                                                <v-autocomplete v-show="!getInitialLoading"
                                                                clearable
                                                                :items="getVats"
                                                                label="VAT/Tax"
                                                                v-model="selectedSupplierOrderProforma.vats_id"
                                                                item-value="id"
                                                                item-text="name"

                                                ></v-autocomplete>

                                            </v-flex>

                                            <v-flex xs12 md6 pl-4 pa-2>
                                                <FakeItem v-show="getInitialLoading">
                                                </FakeItem>
                                                <v-autocomplete v-show="!getInitialLoading"
                                                                clearable
                                                                v-model="selectedSupplierOrderProforma.currencies_id"
                                                                :items="getCurrencies"
                                                                label="Currency"
                                                                item-value="id"
                                                                item-text="name"
                                                ></v-autocomplete>
                                            </v-flex>


                                        </v-layout>


                                        <!--                                        <v-flex xs12 pa-3>
                                                                                    <v-subheader>Outgoing Contact</v-subheader>
                                                                                    <v-divider></v-divider>
                                                                                </v-flex>-->

                                        <!--                                        <v-flex xs12 md6 pl-4 pr-4>
                                                                                    <FakeItem v-show="getInitialLoading">
                                                                                    </FakeItem>
                                                                                    <v-autocomplete v-show="!getInitialLoading"
                                                                                                    clearable
                                                                                                    v-model="selectedItem.accounts_id"
                                                                                                    :items="allAccounts"
                                                                                                    label="Account"
                                                                                                    item-value="id"
                                                                                                    :filter="customContactFilter"
                                                                                    >
                                                                                        <template slot="item" slot-scope="data">
                                                                                            <v-list-tile-content>
                                                                                                <v-list-tile-title>
                                                                                                    {{ data.item.title ? data.item.title : '' }}
                                                                                                    {{
                                                                                                    data.item.firstname }} {{
                                                                                                    data.item.lastname }}
                                                                                                </v-list-tile-title>
                                                                                            </v-list-tile-content>
                                                                                        </template>

                                                                                        <template slot="selection" slot-scope="data">
                                                                                            {{ data.item.firstname }} {{ data.item.lastname }}
                                                                                        </template>

                                                                                        <template slot="no-data">
                                                                                            <v-layout wrap>
                                                                                                <v-flex xs12 pl-4 pr-4>
                                                                                                    <v-btn @click.native="" block
                                                                                                           small flat color="secondary">Create
                                                                                                        New Account
                                                                                                        <v-icon>add</v-icon>
                                                                                                    </v-btn>
                                                                                                </v-flex>
                                                                                            </v-layout>
                                                                                        </template>
                                                                                    </v-autocomplete>
                                                                                </v-flex>-->


                                    </v-card-title>
                                    <v-card-actions>
                                        <v-layout mt-2 pb-3 pr-3>
                                            <v-spacer></v-spacer>
                                            <v-btn dark color="secondary" @click.native="saveAndGoToNextTab(1)">
                                                Save
                                                <v-icon class="white--text" right>save</v-icon>
                                            </v-btn>
                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-hover>
                            <v-layout mt-5 row justify-end>

                            </v-layout>

                        </v-flex>

                    </v-container>
                </v-layout>
            </v-tab-item>
            <v-tab-item>
                <orderPositions></orderPositions>
            </v-tab-item>
            <v-tab-item>
                <sendOrderMessage></sendOrderMessage>
            </v-tab-item>
        </v-tabs-items>
    </v-card>

</template>

<script>
    import {
        Settings,
        Inquiry,
        Customer,
        CustomerBranchOffice,
        CustomerBranchOfficeContact,
        PurchaseOrder,
        Offer,
        SupplierOrder,
        ContactPersonSettings,
        VatSettings,
        SupplierOrderProforma
    } from '../../store/namespace-helper'

    import unconfirmedOfferPositions from '../PurchaseOrders/UnconfirmedOfferPositions/UnconfirmedOfferPositions.vue'
    import orderPositions from '../SupplierOrders/SupplierOrderPositions/SupplierOrderPositions.vue'
    import sendOrderMessage from '../SupplierOrders/SendOrder/SendOrderMessage.vue'
    import DatetimePicker from '../Shared/DatetimePicker.vue'
    import UploadDocumentPicker from '../Shared/UploadDocumentPicker.vue'
    import DocumentTokenChip from '../Shared/DocumentTokenChip.vue'
    import FakeItem from '../Shared/FakeItem.vue'
    import FakeTable from '../Shared/FakeTable.vue'

    import {dateFunctionFilters} from '../../mixins/dateFunctionFilters'
    import {initialLoadingMixin} from '../../mixins/initialLoadingMixin'
    import {deleteDialogMixin} from '../../mixins/deleteDialogMixin'

    import _ from 'lodash'

    export default {
      components: {
        unconfirmedOfferPositions,
        orderPositions,
        sendOrderMessage,
        DatetimePicker,
        UploadDocumentPicker,
        DocumentTokenChip,
        FakeItem,
        FakeTable
      },
      name: 'add-supplier-order',
      mixins: [dateFunctionFilters, initialLoadingMixin, deleteDialogMixin],
      props: {
        procurementId: {
          type: Number,
          default: 0
        }
      },
      data () {
        return {
          headers: [
                    {text: 'Offer-ID', value: 'id'},
                    {text: 'Offer Number', value: 'offer_number'},
                    {text: 'Account', value: 'accounts_id'},
                    {text: 'Status', value: 'customers_offers_status_id'},
                    {text: 'Valid Until', value: 'valid_until'}
          ],
          countries: this.$store.getters.countries,
          selectedOffers: [],
          selectedOfferIDs: [],
          pagination: {'sortBy': 'id', 'descending': true},
          search: '',
          total: 0,
          rowsPageItems: [5, 10, 25, 50, 100, 250],
          customContactFilter (item, queryText, itemText) {
            const isMatch = (test, query) => {
              return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
            }
            const query = queryText || ''
            const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
            const rc = isMatch(item.firstname, query) ||
                        isMatch(item.lastname, query) ||
                        isMatch(item.email, query) ||
                        isMatch(displayText, query)
            console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
            return rc
          },
          isVisible: false,
          supplierContact: {},
          supplierUpdated: 0,
          onDismissed: false,
          sheet: false,
          searchCustomer: '',
          searchCustomerBranchOffice: '',
          searchCustomerBranchOfficeContact: '',
          valid_until: '',
          statuses: [],
          allAccounts: [],
          touchless: true,
          uploadedDocument: null,
          uploadedProformaDocument: null,
          activeTabIndex: 0,
          proforma: false,
          proformaStatuses: []
        }
      },
      mounted () {
        this.loadSupplierContacts(this.selectedItem.suppliers_id)
        this.loadCurrencies()
        this.loadTermsOfDeliveries()
        this.loadTermsOfPayments()
        this.loadStatuses()
        this.loadAllAccounts()
        this.loadAllSuppliers()
        this.loadVats()
        this.loadProformaStatuses()
        this.loadSupplierOrderProforma()
        this.initialLoadingTimeout(850)
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.loadCurrencies()
              this.loadTermsOfDeliveries()
              this.loadTermsOfPayments()
              this.loadStatuses()
              this.loadAllAccounts()
              this.loadAllSuppliers()
              this.loadVats()
              this.loadProformaStatuses()
              this.loadSupplierOrderProforma()
              this.initialLoadingTimeout(850)
            } else {
              this.supplierUpdated = 0
              this.resetInitialLoadingState()
            }
          }
        },
        cancelDeleteDialogCallback () {
          this.proforma = true
        },
        executeDeleteDialogCallback () {
          this.$store.dispatch(SupplierOrderProforma.actions.deleteSupplierOrderProforma, this.deleteData).then(resonse => {
            this.$store.dispatch(SupplierOrderProforma.actions.setSelectedSupplierOrderProforma, null)
            this.saveAndGoToNextTab(1)
          })
        },
        closeDialog () {
          this.$store.dispatch(SupplierOrder.actions.openCloseDialog)
          this.$store.dispatch(SupplierOrder.actions.setSelectedSupplierOrder, null)
          this.$store.dispatch(SupplierOrderProforma.actions.setSelectedSupplierOrderProforma, null)
          this.proforma = false
          this.activeTabIndex = 0
        },
        loadCustomers () {
          const query = {
            search: this.searchCustomer ? this.searchCustomer : ''
          }
          this.$store.dispatch(Customer.actions.loadCustomers, query)
        },
        throttledLoadItems: _.debounce(function () {
          this.loadCustomers()
        }, 450),
        loadCustomerBranchOffices () {
          this.$store.dispatch(CustomerBranchOffice.actions.loadCustomerBranchOffices, this.selectedItem.customers_id)
        },
        throttledLoadUnconfirmedOffers: _.debounce(function () {
          this.loadUnconfirmedOffers()
        }, 450),
        loadUnconfirmedOffers () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : '',
            customers_id: this.selectedItem.customers_id

          }
          this.$store.dispatch(Offer.actions.loadUnconfirmedOffers, query)
        },
        loadCustomerBranchOfficesContacts () {
          this.$store.dispatch(CustomerBranchOfficeContact.actions.loadContactPersons, this.selectedItem.customers_branch_offices_id)
        },
        loadCurrencies () {
          this.$store.dispatch(Settings.actions.loadAllCurrencies)
        },
        loadTermsOfPayments () {
          this.$store.dispatch(Settings.actions.loadTermsOfPayments)
        },
        loadTermsOfDeliveries () {
          this.$store.dispatch(Settings.actions.loadTermsOfDeliveries)
        },
        loadStatuses () {
          this.$store.dispatch(PurchaseOrder.actions.loadStatuses).then(response => {
            this.statuses = response.data.data
          })
        },
        loadAllAccounts () {
          this.$store.dispatch(Settings.actions.loadAllAccounts).then(response => {
            this.allAccounts = response.data.data
          })
        },
        loadAllSuppliers: function () {
          this.$store.dispatch(Settings.actions.loadAllSuppliers)
        },
        loadSupplierContacts (val) {
          this.$store.dispatch(ContactPersonSettings.actions.loadContactPersonsBySupplierId, val)
        },
        saveAndGoToNextTab (index) {
          if (this.proforma) {
            let supplierOrderProforma = {
              id: this.selectedSupplierOrderProforma.id,
              documents_id: this.selectedSupplierOrderProforma.documents_id,
              currencies_id: this.selectedSupplierOrderProforma.currencies_id,
              vats_id: this.selectedSupplierOrderProforma.vats_id,
              suppliers_orders_proforma_status_id: this.selectedSupplierOrderProforma.suppliers_orders_proforma_status_id,
              payment_term_percent: this.selectedSupplierOrderProforma.payment_term_percent,
              proforma_number: this.selectedSupplierOrderProforma.proforma_number,
              total_price: this.selectedSupplierOrderProforma.total_price
            }

            this.$store.dispatch(SupplierOrderProforma.actions.saveSupplierOrderProforma, supplierOrderProforma).then(response => {
              let supplierOrder = {
                id: this.selectedItem.id,
                suppliers_id: this.selectedItem.suppliers_id,
                suppliers_contacts_id: this.selectedItem.suppliers_contacts_id,
                documents_id: this.selectedItem.documents_id,
                suppliers_orders_confirmation_number: this.selectedItem.suppliers_orders_confirmation_number,
                confirmation_received: this.selectedItem.confirmation_received,
                suppliers_orders_proforma_id: this.selectedSupplierOrderProforma.id,
                paid_at: this.selectedItem.paid_at
              }

              this.$store.dispatch(SupplierOrder.actions.saveSupplierOrder, supplierOrder).then(response => {
                this.activeTabIndex = index
              })
            })
          } else {
            let supplierOrder = {
              id: this.selectedItem.id,
              suppliers_id: this.selectedItem.suppliers_id,
              suppliers_contacts_id: this.selectedItem.suppliers_contacts_id,
              documents_id: this.selectedItem.documents_id,
              suppliers_orders_confirmation_number: this.selectedItem.suppliers_orders_confirmation_number,
              confirmation_received: this.selectedItem.confirmation_received,
              paid_at: this.selectedItem.paid_at
            }

            this.$store.dispatch(SupplierOrder.actions.saveSupplierOrder, supplierOrder).then(response => {
              this.activeTabIndex = index
            })
          }
        },
        onDismissedError () {
          this.$store.dispatch(Settings.actions.clearNetworkError)
        },
        openBottomSheet (payload) {
          if (payload) {
            this.$store.dispatch('openCloseBottomSheet')
          }
        },
        loadVats () {
          this.$store.dispatch(VatSettings.actions.loadAllVats)
        },
        loadProformaStatuses () {
          this.$store.dispatch(SupplierOrderProforma.actions.loadStatuses).then(response => {
            this.proformaStatuses = response.data.data
          })
        },
        loadSupplierOrderProforma () {
          if (this.selectedItem.suppliers_orders_proforma_id !== null && this.selectedItem.suppliers_orders_proforma_id > 0) {
            this.extendTimeout()
            this.proforma = true
            this.$store.dispatch(SupplierOrderProforma.actions.loadSupplierOrdersProforma, this.selectedItem.suppliers_orders_proforma_id).then(response => {
            })
          }
        }
      },
      computed: {
        dialog () {
          return this.$store.getters[Inquiry.getters.getOpenInquiryDialogState]
        },
        selectedItem () {
          console.log('selected supplier order: ' + JSON.stringify(this.$store.getters[SupplierOrder.getters.getSelectedSupplierOrder]))
          return this.$store.getters[SupplierOrder.getters.getSelectedSupplierOrder]
        },
        selectedSupplierOrderProforma () {
          return this.$store.getters[SupplierOrderProforma.getters.getSelectedSupplierOrderProforma]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        },
        getCustomers () {
          return this.$store.getters[Customer.getters.customers]
        },
        getCustomerBranchOffices () {
          return this.$store.getters[CustomerBranchOffice.getters.getCustomerBranchOffices]
        },
        getCustomerBranchOfficesContacts () {
          return this.$store.getters[CustomerBranchOfficeContact.getters.getContactPersons]
        },
        getCurrencies () {
          return this.$store.getters[Settings.getters.getAllCurrencies]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        tabsDisabled () {
          return this.$store.getters[SupplierOrder.getters.getSelectedSupplierOrder].id === 0
        },
        sendSupplierOrderDisabled () {
          let messagesId = this.$store.getters[SupplierOrder.getters.getSelectedSupplierOrder].messages_id
          return messagesId === null || messagesId === 0
        },
        getAllSuppliers () {
          return this.$store.getters[Settings.getters.getAllSuppliers]
        },
        getSupplierContacts () {
          return this.$store.getters[ContactPersonSettings.getters.getContactPersonsForSupplierId]
        },
        getVats () {
          return this.$store.getters[VatSettings.getters.getAllVats]
        },
        cardTitle () {
          if (this.selectedItem.id === 0) {
            return 'Add new'
          } else {
            return 'Edit'
          }
        },
        unconfirmedOffers () {
          this.total = this.$store.getters[Offer.getters.unconfirmedOffers].total
          return this.$store.getters[Offer.getters.unconfirmedOffers].data
        }

      },
      watch: {
        pagination: {
          handler () {
            this.loadUnconfirmedOffers()
          },
          deep: true
        },
        uploadedDocument: {
          handler (val) {
            this.selectedItem.documents_id = val.id
            console.log('uploadedDocuments id: ' + JSON.stringify(val))
          },
          deep: true
        },
        uploadedProformaDocument: {
          handler (val) {
            this.selectedSupplierOrderProforma.documents_id = val.id
            console.log('uploadedDocuments id: ' + JSON.stringify(val))
          },
          deep: true
        },
        selectedOffers: {
          handler (val) {
            this.selectedOfferIDs = val.map(a => a.id)
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadUnconfirmedOffers()
          },
          deep: true
        },
        searchCustomer: {
          handler (val) {
            console.log('searchCustomer data changed: ' + JSON.stringify(val))
            this.throttledLoadItems()
          },
          deep: true

        },
        'selectedItem.suppliers_id': {
          handler (val) {
            if (val !== null) {
              if (val !== 0) {
                this.loadSupplierContacts(val)
              }
            }
          }
        },
        proforma: {
          handler (val) {
            if (val !== null) {
              if (val === false) {
                if (this.selectedSupplierOrderProforma.id > 0) {
                  this.openDeleteDialog(this.selectedSupplierOrderProforma)
                }
              }
            }
          }
        }
      }

    }
</script>


<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

    .fromTop {
        padding-top: 120px;
    }

    .fixSides::before {
        position: absolute;
        content: "";
        background-color: var(--secondary-color);
        height: 100%;
        width: 110vw;
        top: 0px;
        left: -24px;
    }

    .statusSelecter {
        width: 80px;
    }

    .header-switch {
        position: absolute;
        right: 24px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Shared/AddSupplierOrder.vue